import { RootState } from 'editor/src/store/index';

import getDpiLevelsFromDesign from 'editor/src/util/design/getDpiLevelsFromDesign';

const getCurrentDpiLevels = (state: RootState) =>
  getDpiLevelsFromDesign(state.design.designData, state.hostSettings.printTechRules);

export default getCurrentDpiLevels;
